import { get, post } from "utilities/network";
export type FiatCurrency = "NGN" | "GHS" | "KES" | "USD";
export interface PendingRelease {
  enabled: boolean;
  periodValue: number;
  periodUnit: "hours" | "days" | "months";
  limitsByCurrency: Record<Exclude<FiatCurrency, "USD">, number>;
}
export interface PaymentWalletConfig {
  currencies: FiatCurrency[];
  providers: { key: string; name?: string; title?: string }[];
  activeProviderByCurrency: Partial<Record<FiatCurrency, string>>;
  activeWalletByProvider: Record<string, FiatCurrency>;
  directChargeMinDepositByCurrency: { GHS: number; KES: number };
  pendingBalanceRelease: PendingRelease;
}
export interface BalanceThresholds {
  thresholds: Record<string, Partial<Record<FiatCurrency, number>>>;
  providers: PaymentWalletConfig["providers"];
  currencies: FiatCurrency[];
}
const root = "admin/transactions";
export const paymentOperationsApi = {
  config: (): Promise<PaymentWalletConfig> =>
    get(`${root}/paymentWalletConfig`),
  thresholds: (): Promise<BalanceThresholds> =>
    get(`${root}/operationalBalanceThresholds`),
  saveProvider: (currency: FiatCurrency, provider: string) =>
    post(`${root}/setActiveProviderForCurrency`, { currency, provider }),
  refresh: async (): Promise<{ message: string; warnings: string[] }> =>
    (await post(`${root}/refreshSystemSettings`, {})).data,
  saveWallet: (provider: string, currency: FiatCurrency) =>
    post(`${root}/setActiveWalletForProvider`, { provider, currency }),
  saveMinimums: (
    values: PaymentWalletConfig["directChargeMinDepositByCurrency"],
  ) => post(`${root}/setDirectChargeMinDeposit`, values),
  saveRelease: (values: PendingRelease) =>
    post(`${root}/setPendingBalanceRelease`, values),
  saveThresholds: (thresholds: BalanceThresholds["thresholds"]) =>
    post(`${root}/operationalBalanceThresholds`, { thresholds }),
};
